export const SuspendedOutline = (props) => (
  <svg
    width='34'
    height='34'
    viewBox='0 0 34 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...props?.style }}
  >
    <rect x='0.5' y='0.5' width='33' height='33' rx='16.5' stroke='#EF4444' />
    <circle cx='17.0003' cy='16.9998' r='13.3333' fill='#EF4444' />
    <path
      d='M17 22.333C17.7363 22.333 18.3338 22.9298 18.334 23.666C18.334 24.4024 17.7364 25 17 25C16.2638 24.9998 15.667 24.4023 15.667 23.666C15.6672 22.9299 16.2639 22.3332 17 22.333ZM17 10.333C17.7363 10.333 18.3338 10.9298 18.334 11.666V18.333C18.334 19.0694 17.7364 19.666 17 19.666C16.2638 19.6658 15.667 19.0693 15.667 18.333V11.666C15.6672 10.9299 16.2639 10.3332 17 10.333Z'
      fill='white'
    />
  </svg>
);
